exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.label-container[data-v-eeba0304] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  z-index: 11;\n  margin: -73px 10px 10px 430px;\n  overflow-y: auto;\n}\n.section[data-v-eeba0304] {\n  padding-bottom: 80px;\n}\n@media all and (max-width: 960px) {\n.label-container[data-v-eeba0304] {\n    margin: 10px 10px 0 60px;\n}\n.section[data-v-eeba0304] {\n    padding-bottom: 0;\n}\n}\n@media all and (max-width: 768px) {\n.label-container[data-v-eeba0304] {\n    margin: 10px 10px 0 30px;\n}\n}\n@media all and (max-width: 480px) {\n.label-container[data-v-eeba0304] {\n    margin: 10px 20px 0 20px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-eeba0304","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/postcss-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionTalking.vue
// module id = 379
// module chunks = 0